// oxlint-disable typescript/no-explicit-any
import type { SliceDefinition } from '../../../canvas/core';
import { pageLayoutSlice } from './slice';

export const withDocumentPagesSlice = <
  const T extends readonly SliceDefinition<any, any>[],
>(
  slices: T
): readonly [typeof pageLayoutSlice, ...T] => [pageLayoutSlice, ...slices];
